import {
  selectMetaForPage,
  fetchMetasByAlias,
  setPegaMetas,
} from "features/admin/Meta/metasAdminSlice";

import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router";

export const useMetaData = () => {
  const dispatch = useDispatch();
  const metaData = useSelector(selectMetaForPage);
  const location = useLocation();
  useEffect(() => {
    const paths = window.location.pathname.split("/");
    if (paths.length == 2) {
      dispatch(fetchMetasByAlias(paths[1] === "" ? "index" : paths[1]));
    }
    return () => {
      dispatch(setPegaMetas({}));
    };
  }, [dispatch, location]);

  return metaData;
};
